import { useState } from "react"

import { CollectionItem } from "@vertesia/common"
import { toast } from "sonner"

import { useUserSession } from "@session/UserSession"

import { Button } from "@ui/button"
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@ui/dialog"

interface DeleteCollectionModalProps {
    collection: CollectionItem
    open: boolean
    setOpen: (open: boolean) => void
    onDelete: () => void
}
export function DeleteCollectionModal({ collection, open, setOpen, onDelete }: Readonly<DeleteCollectionModalProps>) {
    const { client } = useUserSession()

    const [isDeleting, setIsDeleting] = useState(false)

    const deleteCollection = () => {
        setIsDeleting(true)

        client.store.collections
            .delete(collection.id)
            .then(() => {
                toast.success("Collection Deleted", {
                    description: `Collection ${collection.id} has been deleted successfully`,
                    duration: 4000,
                })
                onDelete()
                setOpen(false)
            })
            .catch((error) => {
                toast.error("Error Deleting Collection", {
                    description: error.message,
                    duration: 4000,
                })
                setIsDeleting(false)
            })
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Delete Collection</DialogTitle>
                </DialogHeader>
                <p>Are you sure you want to delete this collection?</p>
                <DialogFooter>
                    <Button variant="destructive" onClick={() => setOpen(false)} disabled={isDeleting}>
                        Cancel
                    </Button>
                    <Button variant="outline" onClick={deleteCollection} disabled={isDeleting}>
                        {isDeleting ? "Deleting..." : "Delete"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
